import { defineComponent as _defineComponent } from 'vue'
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';

interface TagsProps {
  label: string;
  imageSrc?: string;
  altName?: string;
  isIconShown?: boolean;
  isRemoveIconShown?: boolean;
}

interface Emits {
  (e: 'onTagClicked'): void;
  (e: 'onTagRemove', data: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagCell.ts',
  props: {
    label: null,
    imageSrc: null,
    altName: null,
    isIconShown: { type: Boolean, default: false },
    isRemoveIconShown: { type: Boolean, default: true }
  },
  emits: ["onTagClicked", "onTagRemove"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onTagClicked'): void;
  (e: 'onTagRemove', data: string): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, OptimizerIcon }
}

})